import router from "@/router";
import axios from "axios";
import {
  Message
} from "element-ui";

const YHtance = axios.create({
  // baseURL: "http://localhost",
  baseURL: 'https://spapi.wearehpr.cn'
});

let loginRedirectInProgress = false;

function redirectToLogin() {
  if (router.currentRoute.path === '/login' || loginRedirectInProgress) return;
  loginRedirectInProgress = true;
  router.replace('/login')
    .catch(() => { })
    .finally(() => { loginRedirectInProgress = false; });
}

// 请求拦截器
YHtance.interceptors.request.use(
  (req) => {
    if (sessionStorage.getItem("LoginInfo") !== null) {
      const Token = JSON.parse(sessionStorage.getItem("LoginInfo")).Token;
      if (Token) {
        req.headers.Authorization = 'Bearer ' + Token;
      }
      return req;
    }
    return req;
  },
  (err) => {
    return Promise.reject(err);
  }
);

YHtance.interceptors.response.use(
  (res) => {
    if (res.data.message === "用户不存在！") {
      Message.error("当前账号Token已过期！请重新登录！");
      sessionStorage.removeItem("Token");
      sessionStorage.removeItem("LoginInfo");
      redirectToLogin();
      return res;
    }
    return res;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default YHtance;
